import APIs from './index';
import { get, post } from '@/utils/request/mAxios';
import axios from 'axios';
import {
  CretateNewDocBody, DocInfoUpdateBody, DocTreeUpdateBody,
  DocChangeBody, DocDeleteBody, APIListQuery, ApiDocContentQuery,
  DocContentQuery, DocTreeQuery, MultiDocUpdateBody,
} from '../Types';

export function getDocPlatformTree(params: DocTreeQuery) {
  return get(APIs.getDocPlatformTree, params);
}

export function getDocContext(params: DocContentQuery) {
  return get(APIs.getDocContext, params);
}

export function createNewDoc(data: CretateNewDocBody) {
  return post(APIs.createNewDoc, data);
}

export function updateDocInfo(data: DocInfoUpdateBody) {
  return post(APIs.updateDocInfo, data);
}

export function docRelease(data: DocChangeBody) {
  return post(APIs.docRelease, data);
}

export function docOnline(data: DocChangeBody) {
  return post(APIs.docOnline, data);
}
export function docOffline(data: DocChangeBody) {
  return post(APIs.docOffline, data);
}

export function deleteDoc(data: DocDeleteBody) {
  return post(APIs.deleteDoc, data);
}

export function getApiList(params: APIListQuery) {
  return get(APIs.getApiList, params);
}

export function updateDocTree(data: DocTreeUpdateBody) {
  return post(APIs.updateDocTree, data);
}

export function previewAPIContent(params: ApiDocContentQuery) {
  return get(APIs.previewAPIContent, params);
}

export function updateMultiDocInfo(data: MultiDocUpdateBody) {
  return post(APIs.updateMultiDocInfo, data);
}

export function uploadFile(data: any, config: any = {}) {
  return axios({
    method: 'post',
    url: APIs.uploadFile,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    ...config,
  });
}
